import { useCmsCollection, useCmsList } from './useCms';
import { PAGE, pick } from '../lib/content';
import { useSite } from '../hooks/useSite';

export function useEducationData() {
  const { pathFor } = useSite();
  const homePath = pathFor(PAGE.home);
  const educationPath = pathFor(PAGE.education);
  const homeSections = useCmsList('page_sections', { page_path: homePath, sort: 'sort_order', order: 'asc', limit: 30 }, Boolean(homePath));
  const educationSections = useCmsList('page_sections', { page_path: educationPath, sort: 'sort_order', order: 'asc', limit: 20 }, Boolean(educationPath));
  const outcomes = useCmsList('education_content', { term: 'education-area:udbytte', sort: 'sort_order', order: 'asc', limit: 10 });
  const roadmap = useCmsList('education_content', { term: 'education-area:forloeb', sort: 'sort_order', order: 'asc', limit: 12 });
  const business = useCmsList('education_content', { term: 'education-area:forretning', sort: 'sort_order', order: 'asc', limit: 20 });
  const educationPrices = useCmsList('price_items', { term: 'price-category:uddannelse', sort: 'sort_order', order: 'asc', limit: 10 });
  const faq = useCmsList('faq_entries', { sort: 'sort_order', order: 'asc', limit: 30 });
  const stories = useCmsCollection('student_stories');
  const teachers = useCmsCollection('instructors');
  const homeSection = (key) => homeSections.items.find((section) => section.section_key === key);
  const educationSection = (key) => educationSections.items.find((section) => section.section_key === key);
  const coursePrice = educationPrices.items.find((item) => pick(item.name).toLowerCase().includes('hundefrisør')) || educationPrices.items[0];
  return { homeSection, educationSection, outcomes: outcomes.items, roadmap: roadmap.items, business: business.items, coursePrice, faq: faq.items, story: stories.items[0], teacher: teachers.items[0] };
}
